"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var Brands = function Brands(_ref) {
  var onChange = _ref.onChange,
    brands = _ref.brands,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('form__brand_container', className)
  }, /*#__PURE__*/_react.default.createElement("select", {
    className: "form__brand",
    onChange: onChange,
    "aria-label": "Select a brand",
    "data-test-id": "brand-select"
  }, brands.sort(function (a, b) {
    return a.name.localeCompare(b.name);
  }).map(function (_ref2, idx) {
    var name = _ref2.name,
      value = _ref2.value,
      selected = _ref2.selected;
    return /*#__PURE__*/_react.default.createElement("option", {
      key: name + idx,
      value: value,
      selected: selected
    }, name);
  })));
};
Brands.propTypes = {
  onChange: _propTypes.default.func,
  className: _propTypes.default.string,
  brands: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    value: _propTypes.default.string
  }))
};
var _default = Brands;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/pf-payment-calculator-v2/dist/client/components/scss/index.scss');